const UUID_V4_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const STORAGE_KEY_PREFIX = 'scanafy:scan-visitor:v1';
const inMemoryVisitorIds = new Map<string, string>();

function normalizeUuidV4(value: unknown): string | null {
  if (typeof value !== 'string' || value.length !== 36 || !UUID_V4_PATTERN.test(value)) {
    return null;
  }

  return value.toLowerCase();
}

function createUuidV4(): string | null {
  const cryptoApi = globalThis.crypto;
  if (!cryptoApi) {
    return null;
  }

  if (typeof cryptoApi.randomUUID === 'function') {
    return cryptoApi.randomUUID().toLowerCase();
  }

  if (typeof cryptoApi.getRandomValues !== 'function') {
    return null;
  }

  const bytes = cryptoApi.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');

  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function getScanVisitorId(companyId: string, propertyId: string): string | null {
  const storageKey = `${STORAGE_KEY_PREFIX}:${companyId}:${propertyId}`;

  try {
    const storedVisitorId = normalizeUuidV4(window.localStorage.getItem(storageKey));
    if (storedVisitorId) {
      return storedVisitorId;
    }

    const visitorId = createUuidV4();
    if (!visitorId) {
      return null;
    }

    window.localStorage.setItem(storageKey, visitorId);
    return visitorId;
  } catch (_error) {
    const inMemoryVisitorId = inMemoryVisitorIds.get(storageKey);
    if (inMemoryVisitorId) {
      return inMemoryVisitorId;
    }

    const visitorId = createUuidV4();
    if (!visitorId) {
      return null;
    }

    inMemoryVisitorIds.set(storageKey, visitorId);
    return visitorId;
  }
}
